import { environment } from 'environments/environment';

/**
 * Domínios que precisam de Bearer token
 */
export const ALLOWED_AUTH_DOMAINS = [
	environment.baseURL.replace(/^https?:\/\//, ''),
	environment.websocketURL.replace(/^https?:\/\//, ''),
	environment.reportApiURL.replace(/^https?:\/\//, ''),
];

/**
 * Rotas dos domínios acima que não precisam de Bearer Token
 */
export const DISALLOWED_AUTH_PATH = [
	'/user/login',
	'/user/login/external',
	'/user/validateToken',
	'/user/forgotPassword',
	'/user/passwordReset',
	'/user/sendToken',
	'/user/refreshtoken',
	'/files/external',
];
